import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  // Apenas as rotas dashboard e accounts-dashboard são restritas para parceiros
  private partnerRestrictedRoutes = [
    '/dashboard'
  ];

  constructor(private router: Router, private authService: AuthService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    return this.checkAccess(state);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    return this.checkAccess(state);
  }

  private checkAccess(state: RouterStateSnapshot): boolean | UrlTree {
    // Se não estiver logado, redireciona para o login
    if (!this.authService.isUserLoggedIn()) {
      return this.router.createUrlTree(['/login']);
    }

    // Verificar se o usuário é um parceiro tentando acessar dashboard ou accounts-dashboard
    if (this.authService.isPartner()) {
      // Captura a URL atual
      const currentUrl = state.url;
      
      // Verifica se é uma das duas rotas restritas para parceiros
      const isRestrictedRoute = this.partnerRestrictedRoutes.some(route => 
        currentUrl === route || 
        currentUrl.startsWith(route + '/')
      );

      if (isRestrictedRoute) {
        console.log('Parceiro tentando acessar rota restrita:', currentUrl);
        // Redireciona para o dashboard de parceiros
        return this.router.createUrlTree(['/partner-dashboard']);
      }
    }
    
    // Em todos os outros casos, o usuário pode prosseguir
    return true;
  }
}
